const $$splitErrorComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/app/$appId/sub-app/request.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/app/$appId/sub-app/request.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { SubAppRequestFilterParamSchema } from '@apps/main/features/user/pages/app/detail/sub-app/request-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/user/app/$appId/sub-app/request')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: SubAppRequestFilterParamSchema,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});